type OpenApiErrorResponse = {
  status?: "error";
  error?:
    | string
    | {
        message?: string;
      };
  message?: string;
  code?: number;
};

type OpenApiNormalizedError = Error & {
  code?: number;
};

export const normalizeOpenApiError = (
  error: unknown,
): OpenApiNormalizedError => {
  const apiError = error as OpenApiErrorResponse;
  const message =
    typeof apiError.error === "string"
      ? apiError.error
      : typeof apiError.error?.message === "string"
        ? apiError.error?.message
        : typeof apiError.message === "string"
          ? apiError.message
          : "An error occurred";

  const normalizedError = new Error(
    message ?? "An error occurred",
  ) as OpenApiNormalizedError;

  normalizedError.code = apiError.code;

  return normalizedError;
};
